import { apiRequest } from "./apiClient";

export const getSliders = async () => {
 try {
  const data = await apiRequest("/sliders");
  return data.sliders?.length ? data.sliders : [];
 } catch (error) {
  return [];
 }
};
